import axios from "axios";
import toast from "react-hot-toast";
import { errorMessageToast } from "./common";

// Apply base URL for axios
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_VERSION = process.env.REACT_APP_API_VERSION;

const axiosApi = axios.create({
  baseURL: `${API_BASE_URL}${API_VERSION}`,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const updateToken = (token) => {
  if (token) {
    axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosApi.defaults.headers.common["Authorization"];
  }
};

let obj = null;

if (typeof window !== "undefined") {
  obj = JSON.parse(localStorage.getItem("authUser"));
}

updateToken(obj ? obj.authToken : null);

const LogoutUser = () => {
  toast.error("You are logged out.");
  localStorage.clear();
  window.location.replace("/");
};

const checkStatusCode = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    const message = data?.message || data?.error;
    errorMessageToast(message || "Network Error!", {
      id: 'apiError'
    });
    if ([403, 501, 502, 503, 500].includes(status)) {
      throw new Error(data.message || "Server error. Please try again later.");
    } else {
      throw error;
    }
  } else if (error.request) {
    throw new Error("Network error. Please check your connection.");
  } else {
    throw new Error(error.message);
  }
};

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, config);
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    checkStatusCode(error);
  }
}

export async function post(url, data, config = {}) {
  try {
    const response = await axiosApi.post(url, data, config);
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    checkStatusCode(error);
  }
}

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url, data, config);
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    checkStatusCode(error);
  }
}

export async function del(url, config = {}) {
  try {
    const response = await axiosApi.delete(url, config);
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    checkStatusCode(error);
  }
}
